import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { actions } from '../Customers/customers.slice'
import { sendPasswordResetLink } from '../Customers/customers.asynActions'
import { selectSelectedRow } from '../Customers/customers.selectors'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'

const { setSelectedCustomerModal, setSelectedRow } = actions

const ResetUserModal = () => {
	const dispatch = useDispatch()
	const selectedRow = useSelector(selectSelectedRow)
	const [isSending, setIsSending] = useState(false)

	const { id, email, userName, lastLogin } = selectedRow
	const isInvite = !lastLogin

	const resetModal = () => {
		dispatch(setSelectedCustomerModal(null))
		dispatch(setSelectedRow({}))
	}

	useEffect(() => {
		dispatch(showModal())
	})

	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
	}

	const handleSendResetLink = () => {
		setIsSending(true)
		dispatch(sendPasswordResetLink({ id, isResendInvite: isInvite })).then(() => {
			setIsSending(false)
			dispatch(setSelectedCustomerModal(null))
			dispatch(setSelectedRow({}))
		})
	}

	const footer = (
		<>
			<Button
				className='h-50 w-190'
				variant='outline'
				onClick={handleClose}
			>
				Cancel
			</Button>
			<Button
				className='h-50 w-190'
				onClick={handleSendResetLink}
				disabled={isSending}
			>
				<BusyIndicator region={REGIONS.RESET_CUSTOMER_USER_PASSWORD}>
					{isInvite ? 'Send Invitation' : 'Send Reset Link'}
				</BusyIndicator>
			</Button>
		</>
	)

	return (
		<Modal
			footer={footer}
			reset={resetModal}
			title={isInvite ? 'Resend Invitation' : 'Reset User Password'}
			size='sm'
		>
			<div className='f-14' style={{ textAlign: 'center', padding: '16px 0' }}>
				<p style={{ marginBottom: '8px' }}>
					{isInvite
						? 'Resend the account setup invitation to:'
						: 'Send a password reset link to:'}
				</p>
				<p style={{ fontWeight: 600 }}>
					{userName || email || id}
				</p>
				{email && (
					<p style={{ color: '#666', fontSize: '13px', marginTop: '4px' }}>
						{email}
					</p>
				)}
				<p style={{ color: '#666', fontSize: '13px', marginTop: '16px' }}>
					{isInvite
						? 'The user will receive a welcome email with a secure link to set their password.'
						: 'The user will receive an email with a secure link to set a new password.'}
				</p>
			</div>
		</Modal>
	)
}
export default ResetUserModal
